import { render } from "./ApiUsage.vue?vue&type=template&id=5c36c65a&scoped=true"
import script from "./ApiUsage.vue?vue&type=script&lang=js"
export * from "./ApiUsage.vue?vue&type=script&lang=js"

import "./ApiUsage.vue?vue&type=style&index=0&id=5c36c65a&lang=scss&scoped=true"
import "./ApiUsage.vue?vue&type=style&index=1&id=5c36c65a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c36c65a"]])

export default __exports__